import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import Seo from "../../components/feature/Seo";
import { comics, categories, formatViews } from "../../mocks/comics";

const tabs = [
  { key: "hot", label: "人气热度" },
  { key: "score", label: "高分榜" },
  { key: "pick", label: "编辑精选" },
];

export default function Ranking() {
  const [tab, setTab] = useState("hot");
  const [cat, setCat] = useState("全部");

  const list = useMemo(() => {
    let l = [...comics];
    if (cat !== "全部") l = l.filter((c) => c.category === cat);
    if (tab === "hot") l.sort((a, b) => b.views - a.views);
    else if (tab === "score") l.sort((a, b) => b.score - a.score);
    else l = l.filter((c) => c.isEditorPick).sort((a, b) => b.views - a.views);
    return l;
  }, [tab, cat]);

  const podium = list.slice(0, 3);
  const rest = list.slice(3);

  const catList = ["全部", ...categories.map((c) => c.name)];

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <Seo
        title="策驰漫画网人气排行 - 热门漫画排行榜"
        description="策驰漫画网人气排行综合人气热度与评分，帮你快速定位当下最受欢迎的热门漫画，含人气榜、高分榜与编辑精选榜单。"
        canonical="https://artbinge.github.io/paihang"
      />

      <section className="pt-16 md:pt-[72px] bg-secondary-600 relative overflow-hidden">
        <div className="absolute -bottom-10 -right-8 w-60 h-60 rounded-full bg-accent-500/30 blur-2xl"></div>
        <div className="relative z-10 mx-auto max-w-7xl w-full px-4 md:px-6 py-10 md:py-12">
          <nav aria-label="面包屑" className="text-secondary-100 text-xs md:text-sm mb-3">
            <ol className="flex flex-wrap items-center gap-1.5">
              <li><Link to="/" className="hover:text-background-50">首页</Link></li>
              <li aria-hidden="true"><i className="ri-arrow-right-s-line"></i></li>
              <li className="text-background-50">人气排行</li>
            </ol>
          </nav>
          <h1 className="font-heading text-3xl md:text-4xl text-background-50">漫画人气排行榜</h1>
          <p className="mt-2 text-secondary-100 text-sm md:text-base">综合人气热度与评分，帮你快速定位当下最受欢迎的热门漫画</p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl w-full px-4 md:px-6 py-8 md:py-10">
        {/* 分类选择 */}
        <div className="flex flex-wrap gap-2 mb-6">
          {catList.map((c) => (
            <button key={c} onClick={() => setCat(c)} className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors ${cat === c ? "bg-primary-500 text-background-50" : "bg-background-100 border border-background-200 text-foreground-700 hover:bg-secondary-100"}`}>{c}</button>
          ))}
        </div>

        {/* Tab */}
        <div className="inline-flex items-center gap-1 p-1 bg-background-100 border border-background-200 rounded-full mb-7">
          {tabs.map((t) => (
            <button key={t.key} onClick={() => setTab(t.key)} className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${tab === t.key ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:text-primary-600"}`}>{t.label}</button>
          ))}
        </div>

        {/* 前三领奖台 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          {podium.map((c, i) => (
            <Link
              key={c.id}
              to={`/manhua/${c.id}`}
              className={`relative flex items-center gap-4 p-4 rounded-2xl border transition-all hover:-translate-y-1 ${
                i === 0 ? "bg-primary-50 border-accent-300 shadow-soft" : "bg-background-100 border-background-200/70"
              }`}
            >
              <span className={`w-12 h-12 shrink-0 rounded-2xl flex items-center justify-center font-heading text-2xl ${i === 0 ? "bg-accent-500 text-foreground-950" : i === 1 ? "bg-secondary-500 text-background-50" : "bg-secondary-200 text-secondary-900"}`}>{i + 1}</span>
              <div className="w-16 h-20 shrink-0 rounded-lg overflow-hidden">
                <img src={c.cover} alt={`${c.title}封面`} className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
              <div className="min-w-0 flex-1">
                <h2 className="font-bold text-foreground-950 text-base truncate">{c.title}</h2>
                <p className="mt-0.5 text-xs text-foreground-600 truncate">{c.category} · {c.author}</p>
                <div className="mt-1.5 flex items-center gap-3 text-xs">
                  <span className="flex items-center gap-1 text-accent-700 font-semibold"><i className="ri-star-fill text-accent-500"></i>{c.score.toFixed(1)}</span>
                  <span className="flex items-center gap-1 text-foreground-500"><i className="ri-eye-line"></i>{formatViews(c.views)}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* 其余排行 */}
        <div className="bg-background-100 border border-background-200/70 rounded-2xl divide-y divide-background-200/60 overflow-hidden">
          {rest.map((c, i) => (
            <Link key={c.id} to={`/manhua/${c.id}`} className="flex items-center gap-4 p-4 hover:bg-background-50 transition-colors group">
              <span className={`w-9 h-9 shrink-0 rounded-lg flex items-center justify-center font-heading text-lg ${i < 4 ? "bg-secondary-200 text-secondary-900" : "text-foreground-400"}`}>{i + 4}</span>
              <div className="w-11 h-14 shrink-0 rounded-md overflow-hidden">
                <img src={c.cover} alt={`${c.title}封面`} className="w-full h-full object-cover object-top" loading="lazy" />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="font-semibold text-foreground-950 text-sm truncate group-hover:text-primary-600">{c.title}</h3>
                <p className="mt-0.5 text-xs text-foreground-600 truncate">{c.category} · {c.author}</p>
              </div>
              <div className="hidden sm:block text-xs text-foreground-500">{c.lastChapter}</div>
              <div className="flex items-center gap-3 shrink-0">
                <span className="flex items-center gap-1 text-accent-700 text-sm font-semibold"><i className="ri-star-fill text-accent-500"></i>{c.score.toFixed(1)}</span>
                <span className="flex items-center gap-1 text-foreground-500 text-xs"><i className="ri-eye-line"></i>{formatViews(c.views)}</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}